<script setup lang="ts">
const t2 = useT2({})

export type Props = {
  nr: string
  type: 'active' | 'next' | 'done'
  label: stringI18n
  onEdit?(): void
}

const props = defineProps<Props>()
const mobile = useMobile()
const on = computed(() => props.type === 'active')
</script>

<template>
  <div class="_mb4 d_pt04 _pb14 m_mr04 m_ml04 _br14 _b5" :class="on && $style.glow">
    <div class="_row _wrap _ctrY _pl08 d_pr14 m_pr04 d_h40 m_hm40 _mb2">
      <CheckoutBoxLabel :on :nr :label :mobile :done="type === 'done'" :edit-msg="undefined" :loading="false" />

      <div v-if="!mobile" class="_mla">
        <ButtonUi2 v-if="type === 'done' && onEdit" :txt="t2('Edit')" :on="false" @click="() => onEdit?.()" />
      </div>
    </div>

    <template v-if="on || type === 'done'">
      <slot />
    </template>

    <div v-if="mobile && type === 'done' && onEdit" class="_pl14 _pr14 _pt2">
      <ButtonUi2 :txt="t2('Edit')" :on="false" max-width @click="() => onEdit?.()" />
    </div>
  </div>
</template>

<style module>
.glow {
  border-color: var(--blue3);
  box-shadow: 0 0 0 3px hsla(240, 100%, 33.9%, 0.1);
}
</style>
